import addError from '../../../utils/error.jsx';
import { subscribe } from './subscription';

export function request(id, eventId, market) {
    return {
        type: 'MARKETS_UPDATE_REQUEST',
        market,
        eventId,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'MARKETS_UPDATE_ERROR',
        errors,
        id
    };
}

export function finish(id, market, response) {
    return {
        type: 'MARKETS_UPDATE_FINISH',
        market,
        id,
        response
    };
}

export function update(id, data) {
    return (dispatch) => {
        dispatch({
            type: 'MARKET_DATA',
            data,
            id
        });

        dispatch(subscribe(id));
    };
}

export function bulk(data) {
    return (dispatch) => {
        data.forEach(x => {
            x.id = parseInt(x.id, 10);
        });

        dispatch({
            type: 'MARKETS_DATA',
            data
        });

        dispatch(subscribe(data.map((market) => market.id)));
    };
}
